import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-select-adicao',
  templateUrl: './select-adicao.component.html',
  styleUrls: ['./select-adicao.component.scss'],
})
export class SelectAdicaoComponent implements OnInit, OnChanges {
  @Input() selectData: any[] = [];
  @Input() label: string = '';
  @Input() labelColor: string = '';
  @Input() disabled: boolean = false;
  @Input() requiredInput: boolean = false;
  @Input() resetList: boolean = false;
  @Output() items = new EventEmitter();
  currentItem: string = '';
  itemsList: any[] = [];

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resetList'] && changes['resetList'].currentValue === true) {
      this.itemsList = [];
      this.items.emit(this.itemsList);
    }
  }

  addItem() {
    const itemToAdd = this.selectData.find(
      (item) => item.value === this.currentItem
    );
    if (itemToAdd) {
      const exist = this.itemsList.find((x) => x.value == itemToAdd.value);

      if (!exist) this.itemsList.push(itemToAdd);
    }

    this.currentItem = '';

    this.items.emit(this.itemsList);
  }

  delItem(itemToRemove: any) {
    const index = this.itemsList.findIndex(
      (item: any) => item.value === itemToRemove.value
    );
    if (index !== -1) {
      this.itemsList.splice(index, 1);
    }

    this.items.emit(this.itemsList);
  }
}
